module.exports = __webpack_public_path__ + "img/expression2.c49c1d87.png";